module.exports = __webpack_public_path__ + "img/recolumn_example6.729a8328.png";